import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

/**
 * The SectionMapMaybe component.
 * Displays the listing location as text (map functionality removed).
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @param {Object} [props.geolocation]
 * @param {Object} [props.publicData]
 * @returns {JSX.Element} section with location info
 */
const SectionMapMaybe = props => {
  const { className, rootClassName, geolocation, publicData } = props;

  if (!geolocation) {
    return null;
  }

  const address = publicData?.location?.address;
  const classes = classNames(rootClassName || css.sectionMap, className);

  return (
    <section className={classes} id="listing-location">
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.locationTitle" />
      </Heading>
      {address ? <p>{address}</p> : null}
    </section>
  );
};

export default SectionMapMaybe;
